import {FocusableOption} from '@angular/cdk/a11y';
import {
    booleanAttribute,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    inject,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'ui-kit-checkbox',
    templateUrl: 'checkbox.component.html',
    styleUrls: ['checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CheckboxComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class CheckboxComponent implements ControlValueAccessor, FocusableOption {
    @HostBinding('class.disabled') classDisabled = false;
    @Input() id: string;
    @Input() testId: string;
    @Input() appearance: 'small' | 'default' = 'default';
    @Input() withLabel = true;
    @Input() disabled: boolean;
    @Output() readonly change = new EventEmitter<CheckboxChange>();
    @ViewChild('input') _inputElement: ElementRef<HTMLInputElement>;

    isHover: boolean;
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _checked: boolean = false;

    @Input({transform: booleanAttribute})
    get checked(): boolean {
        return this._checked;
    }

    set checked(value: boolean) {
        if (value != this.checked) {
            this._checked = value;
            this._changeDetectorRef.markForCheck();
        }
    }

    focus(): void {
        this._inputElement.nativeElement.focus();
    }

    handleInputClick(): void {
        if (!this.disabled) {
            this._checked = !this._checked;
            this._emitChangeEvent();
        }
    }

    onTouch: any = () => {
    };

    registerOnChange(fn: any): void {
        this._controlValueAccessorChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    writeValue(checked: boolean): void {
        this.checked = !!checked;
    }


    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.classDisabled = isDisabled;
    }

    protected _createChangeEvent(isChecked: boolean): CheckboxChange {
        return {
            checked: isChecked,
            source: this,
        };
    }

    private _controlValueAccessorChangeFn: (value: any) => void = () => {
    };

    private _emitChangeEvent(): void {
        this._controlValueAccessorChangeFn(this.checked);
        this.change.emit(this._createChangeEvent(this.checked));

        if (this._inputElement) {
            this._inputElement.nativeElement.checked = this.checked;
        }
    }
}

export interface CheckboxChange {
    source: CheckboxComponent;
    checked: boolean;
}
